export const DATA_QA_UNIQUE_OFFER_CONTAINER = 'unique-offer-container';
export const DATA_QA_UNIQUE_OFFER_TITLE = 'unique-offer-title';
export const DATA_QA_UNIQUE_OFFER_ITEMS_GRID = 'unique-offer-items-grid';
export const DATA_QA_UNIQUE_OFFER_ITEM = 'unique-offer-item';
export const DATA_QA_UNIQUE_OFFER_ITEM_TEXT = 'unique-offer-item-text';
export const DATA_QA_UNIQUE_OFFER_MODAL_ACTION_BUTTON_HREF = 'unique-offer-modal-action-button-href';
export const DATA_QA_UNIQUE_OFFER_MODAL_ACTION_BUTTON_CLOSE = 'unique-offer-modal-action-button-close';
